import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faXTwitter, faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer
      className="text-white text-center py-8 mt-12 text-sm border-t border-gray-800 bg-black"
      style={{
        boxShadow: "0px -4px 8px rgba(250, 234, 205, 0.3)",
      }}
    >
      {/* Social Media */}
      <div className="flex justify-center gap-6 mb-3 text-lg">
        <a
          href="https://www.instagram.com/internationaletheaterkompanie/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="hover:text-brand-red-text transition"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a
          href="https://www.facebook.com/p/Internationale-in-Kunst-eV-100064737574025/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="hover:text-brand-red-text transition"
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </a>
        <a
          href="https://x.com/TiyatroKumpanya"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X (Twitter)"
          className="hover:text-brand-red-text transition"
        >
          <FontAwesomeIcon icon={faXTwitter} />
        </a>
      </div>

      {/* Address */}
      <div
        className="mb-3"
        dangerouslySetInnerHTML={{ __html: t("footer.address") }}
      />

      {/* Legal Links */}
      <div className="mb-3 flex justify-center items-center gap-2">
        <a
          href="/datenschutz"
          className="text-gray-400 hover:text-brand-red-text transition text-sm"
        >
          {t("footer.datenschutz")}
        </a>
        <span className="text-gray-400 text-sm">·</span>
        <a
          href="/impressum"
          className="text-gray-400 hover:text-brand-red-text transition text-sm"
        >
          {t("footer.impressum")}
        </a>
      </div>

      {/* Design Info */}
      <div
        className="text-gray-400 mb-1"
        dangerouslySetInnerHTML={{ __html: t("footer.designInfo") }}
      />

      {/* Copy Right */}
      <div
        className="text-gray-400 text-xs mt-2"
        dangerouslySetInnerHTML={{
          __html: t("footer.copyright", { year: new Date().getFullYear() }),
        }}
      />
    </footer>
  );
};

export default Footer;